import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import './Home.css';

class Home extends Component {
  handleLogin = () => {
    browserHistory.replace('/login');
  }

  render() {
    return (
      <div className="Home">
        <header className="bg-secondary row text-center">
          <div className="col my-auto">
            <h1 className="display-4"> Welcome to Rype </h1>
            <p className="lead mb-1 mt-4">Speak a New Language With Confidence.</p>
          </div>
        </header>

        <section>
          <div className="row">
            <div className="content-wrapper col">
              <div className="pt-4 text-center">
                <p>
                  <span className="font-weight-bold"> Log In </span> or
                  <span className="font-weight-bold"> Sign Up </span> to start booking language
                  lessons with our handpicked, professional teachers!
                </p>
                <p className="lead text-center mt-4">
                  <button
                    type="button"
                    className="btn btn-primary btn-cursor btn-lg px-5"
                    onClick={this.handleLogin}
                  >
                    Log In / Sign Up
                  </button>
                </p>
                <p className="small text-muted mt-2">
                  Are you a newly registered member? <br />
                  Finish signing up by creating an account with the same email you registered with.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/Home.js